import Phaser, { Curves } from 'phaser'
// import MovingObstacle from './movingObstacle'
import RotatingParticle from './rotatingParticle'
import Platform from './platform'
import { AnimalDef, ChainDef } from '/components/animalDef'
import { AnimalDefinitions } from '/components/animalDefinitions'

export const SPEED = 15
export const ACCEL = 10
export const DECEL = 1
export const SIZE = 80// 65
const BOUNCINESS = 1.325
const START_Y = -50// 150

export const NAMES_S = [
  'cats',
  'dogs',
  'racoons',
  'giraffes',
  'pigs',
  'elephants',
  'penguins',
  'unicorns',
  'mice',
  'bunnies',
  'fish',
  'robots',
  'pugs',
  'black cats',
  'turtles',
  'pandas',
  'jellyfish',
  'fancy cats'
]

export const NAMES = [
  'cat',
  'dog',
  'racoon',
  'giraffe',
  'pig',
  'elephant',
  'penguin',
  'unicorn',
  'mouse',
  'bunny',
  'fish',
  'robot',
  'pug',
  'black cat',
  'turtle',
  'panda',
  'jellyfish',
  'fancy cat'
]

export const CAT = 0
export const DOG = 1
export const RACOON = 2
export const GIRAFFE = 3
export const PIG = 4
export const ELEPHANT = 5
export const PENGUIN = 6
export const UNICORN = 7
export const MOUSE = 8
export const BUNNY = 9
export const FISH = 10
export const ROBOT = 11
export const PUG = 12
export const BLACK_CAT = 13
export const TURTLE = 14
export const PANDA = 15
export const JELLY = 16
export const WHITE_CAT = 17

export const SANTA = 99

export default class Player extends Phaser.GameObjects.Container {
  constructor (scene, lastY, useNextColor, selectedAnimal) {
    super(scene)

    this.scene = scene

    this.lastGroundY = 550
    this.gameoverThreshold = 1000

    this.hasStarted = false
    this.selectedHat = selectedAnimal === WHITE_CAT

    this.score = 0
    this.combo = 1
    this.comboTimer = 0
    this.nBouncesThisCombo = 0
    this.nSpikesThisCombo = 0

    this.stretch = 1
    this.strechtDown = true

    this.canMove = true
    this.isGameOver = false
    this.fellInGap = false

    this.godMode = false
    if (process.env.NODE_ENV !== 'production') {
      this.scene.input.keyboard.on('keyup-M', () => {
        this.scene.game.registry.set('selectedAnimal', (this.selectedAnimal + 1) % 18)
        this.scene.game.registry.set('lastPlayerY', -200)
        this.poof()
        setTimeout(() => { this.scene.restart(false) }, 400)
      })
    }

    this.setAnimal(selectedAnimal)// useNextColor ? -100 : lastY)
    this.image.setCircle(49)
    this.image.setSize(SIZE, SIZE)
    this.image.setDisplaySize(SIZE, SIZE)
    this.colorIndex = 0xffffff// color
    this.image.setBounce(BOUNCINESS)
    this.image.setFixedRotation()
    // this.image.setDepth(500)
    this.image.setOnCollide((collisionData) => { this.onCollision(collisionData) })
    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory1)
    this.image.setCollidesWith(this.scene.collisionCategory2)
    this.add(this.image)
    this.image.setOrigin(0.80, 0.835)

    if (this.selectedAnimal === UNICORN) {
      this.image.setScale(0.62, 0.62)
      this.image.setOrigin(0.80, 1.425)
    }

    this.keyRight = this.scene.input.keyboard.addKey('right')
    this.keyLeft = this.scene.input.keyboard.addKey('left')

    this.bounceParticles = this.scene.add.particles('images', 'circle')
    this.bounceParticles.setDepth(3)

    this.exhaust = this.bounceParticles.createEmitter({
      on: false,
      active: true,
      frequency: 1,
      quantity: 1,
      lifespan: 400,
      scale: { start: 0.28, end: 0 },
      alpha: { start: 1, end: 0 },
      follow: this.image
    })

    this.explode = this.bounceParticles.createEmitter({
      speed: { min: 150, max: 200 },
      angle: { min: 190, max: 230 },
      scale: { start: 0.08, end: 0.16 },
      alpha: { start: 1, end: 0 },
      quantity: 10,
      lifespan: 800,
      gravityY: 300,
      gravityX: 200,
      on: false
    })
    this.explode2 = this.bounceParticles.createEmitter({
      speed: { min: 150, max: 200 },
      angle: { min: 310, max: 350 },
      scale: { start: 0.08, end: 0.16 },
      alpha: { start: 1, end: 0 },
      quantity: 10,
      lifespan: 800,
      gravityY: 300,
      gravityX: -200,
      on: false
    })

    this.cakeParticles = this.scene.add.particles('images', 'circle')
    this.cakeParticles.setDepth(510)
    this.cakePa = this.cakeParticles.createEmitter({
      tint: 0xFFFFE4,
      speed: { min: 200, max: 400 },
      // angle: { min: 210, max: 330 },
      scale: { start: 0.7, end: 0.04 },
      // blendMode: 'SCREEN',
      quantity: 20,
      lifespan: 700,
      gravityY: 1000,
      on: false
      // radial: true
    })

    this.berryParticles = this.scene.add.particles('images', 'berry')
    this.berryParticles.setDepth(1020)
    this.berryP = this.berryParticles.createEmitter({
      // tint: 0xFFFFE4,
      speed: 800,
      angle: { min: 225, max: 315 },
      // scale: { start: 0.2, end: 0 },
      scale: 0.5,
      // blendMode: 'SCREEN',
      quantity: 1,
      lifespan: 4000,
      gravityY: 1000,
      on: false,
      rotate: { onEmit: function (particle, key, t, value) { return Phaser.Math.Between(0, 360) } },
      particleClass: RotatingParticle
      // radial: true
    })

    this.poofP = this.bounceParticles.createEmitter({
      speed: { min: 20, max: 400 },
      // angle: { min: 0, max: 360 },
      // tint: 0x000000,
      scale: { start: 0.8, end: 0 },
      alpha: { start: 1, end: 0 },
      // tint: [0xffffff, 0xffff00, 0x5555ff],
      // tint: { start: 0xffffff, end: 0x000000 },
      quantity: 30,
      lifespan: 400,
      // gravityY: 0,
      gravityY: 1000,
      on: false,
      radial: true
    })

    // this.constraints = []
    // this.tails = []
    this.setAnimalTails()

    if (this.selectedHat) {
      this.addHat()
    }

    // add a predictive sensor
    // this.sensor = this.scene.matter.add.image(0, 0, 'white', 0, { isSensor: true })
    // this.sensor.setSize(800, 10)
    // this.sensor.setDisplaySize(800, 10)
    // this.sensor.setOnCollide((collisionData) => { this.onSensor(collisionData) })
    // this.sensor.setVisible(false)
    // this.sensor.setIgnoreGravity(true)
  }

  setAnimal (index) {
    if (this.image) {
      this.image.destroy()
    }

    this.selectedAnimal = index
    this.animalDef = new AnimalDef()
    switch (this.selectedAnimal) {
      default:
      case CAT:
        this.animalDef = AnimalDefinitions.getCat()
        break
      case DOG:
        this.animalDef = AnimalDefinitions.getDog()
        break
      case RACOON:
        this.animalDef = AnimalDefinitions.getRacoon()
        break
      case MOUSE:
        this.animalDef = AnimalDefinitions.getMouse()
        break
      case BLACK_CAT:
        this.animalDef = AnimalDefinitions.getBlackCat()
        break
      case WHITE_CAT:
        this.animalDef = AnimalDefinitions.getWhiteCat()
        break
      case TURTLE:
        this.animalDef = AnimalDefinitions.getTurtle()
        break
      case ELEPHANT:
        this.animalDef = AnimalDefinitions.getElephant()
        break
      case ROBOT:
        this.animalDef = AnimalDefinitions.getRobot()
        break
      case BUNNY:
        this.animalDef = AnimalDefinitions.getBunny()
        break
      case PANDA:
        this.animalDef = AnimalDefinitions.getPanda()
        break
      case GIRAFFE:
        this.animalDef = AnimalDefinitions.getGiraffe()
        break
      case UNICORN:
        this.animalDef = AnimalDefinitions.getUnicorn()
        break
      case FISH:
        this.animalDef = AnimalDefinitions.getFish()
        break
      case PENGUIN:
        this.animalDef = AnimalDefinitions.getPenguin()
        break
      case JELLY:
        this.animalDef = AnimalDefinitions.getJelly()
        break
      case PIG:
        this.animalDef = AnimalDefinitions.getPig()
        break
      case PUG:
        this.animalDef = AnimalDefinitions.getPug()
        break
    }

    this.animalDef.createAnimal(0, START_Y, this, this.scene)
  }

  poof () {
    this.image.setVisible(false)
    for (var i = 0; i < this.tails.length; i++) {
      this.tails[i].setVisible(false)
    }

    // if (this.image.body.velocity.y < -2) {
    //   this.poofP.setAngle({ min: 120, max: 60 })
    // } else if (this.image.body.velocity.y > 2) {
    //   this.poofP.setAngle({ min: 60, max: 120 })
    // } else {

    // }

    // this.poofP.setGravityY(this.image.body.velocity.y * 100)
    this.image.setIgnoreGravity(true)
    this.image.setStatic(true)

    this.poofP.setPosition(this.image.x, this.image.y)
    this.poofP.explode()
  }

  setAnimalTails () {
    this.constraints = []
    this.tails = []
    this.animalDef.createTails(0, START_Y)
  }

  addHat () {
    this.hasHat = true
    this.hat = this.scene.matter.add.image(0, 0, 'images', 'hat')
    this.hat.setScale(0.5)
    this.hat.setCollisionGroup(-1)
    this.hat.setCollisionCategory(0)
    this.hat.setIgnoreGravity(true)
    this.hat.setTint(0)
    this.hat.setDepth(650)
  }

  // return a color string - with at least 444444
  genHexString (len) {
    let output = ''
    for (let i = 0; i < len; ++i) {
      output += (Math.floor(4 + Math.random() * 12)).toString(16)
    }
    return output
  }

  setupInput () {
    this.keySpace = this.scene.input.keyboard.addKey('space')
    this.keyEditor = this.scene.input.keyboard.addKey('Q')
    this.keyEsc = this.scene.input.keyboard.addKey('esc')
    this.keyEscWasDown = false
  }

  doStretch (value, down) {
    this.stretch = value
    this.strechtDown = down
  }

  updateTails () {
    if (this.tails.length <= 0) {
      return
    }

    // set correct rotation of all links in the chain:
    for (var i = 0; i < this.tails.length; i++) {
      var diff = new Phaser.Math.Vector2()
      diff.x = this.constraints[i].bodyB.position.x - (this.constraints[i].bodyA.position.x + this.constraints[i].pointA.x)
      diff.y = this.constraints[i].bodyB.position.y - (this.constraints[i].bodyA.position.y + this.constraints[i].pointA.y)
      this.tails[i].setRotation(diff.angle() - 0.5 * Math.PI)
    }

    // pointing arms towards cake:
    if (this.cake && this.cake.image) {
      var cakeDistX = Math.abs(this.image.x - this.cake.image.x)
      var cakeDistY = Math.abs(this.image.y - this.cake.image.y)

      if ((cakeDistX < 1000 && cakeDistX > 100) || (cakeDistX < 150 && cakeDistY > 150)) {
        this.cakeDirL = new Phaser.Math.Vector2(this.cake.image.x - this.tails[this.leftArmIndx].x, this.cake.image.y - this.tails[this.leftArmIndx].y)
        this.cakeDirL.normalize()
        this.cakeDirR = new Phaser.Math.Vector2(this.cake.image.x - this.tails[this.rightArmIndx].x, this.cake.image.y - this.tails[this.rightArmIndx].y)
        this.cakeDirR.normalize()

        var scale = -100
        if (this.selectedAnimal === PANDA) {
          scale = -60
        } else if (this.selectedAnimal === ROBOT) {
          scale = 2
        }

        this.cakeDirL.scale(scale)
        this.cakeDirR.scale(scale)

        if ((this.image.x <= this.cake.image.x && (this.image.rotation > 0.5 || this.image.rotation < -2.05)) ||
        (this.image.x > this.cake.image.x && (this.image.rotation < -0.5 || this.image.rotation > 2.05))) {
          this.pointArmsToCake()
        }
      }

      if (this.scene.finished) {
        this.pointArmsToCake()
        this.moveLegsApart()
      }
    }

    if (this.isGameOver) {
      this.moveArmsApart()
      this.moveLegsApart()
    }

    if (this.animalDef.stiffenNeck) {
      var neckDir
      var j

      if (this.selectedAnimal === GIRAFFE || this.selectedAnimal === ROBOT || this.selectedAnimal === TURTLE) {
        neckDir = new Phaser.Math.Vector2(0, -14)
        neckDir.rotate(this.image.rotation)
      } else if (this.selectedAnimal === BUNNY) {
        neckDir = new Phaser.Math.Vector2(0, -13)
        neckDir.rotate(this.image.rotation + Math.PI * 0.15)
      }

      for (j = 0; j < this.tailLength; j++) {
        if (this.selectedAnimal === GIRAFFE || this.selectedAnimal === BUNNY || this.selectedAnimal === TURTLE) {
          this.tails[j + this.tailIndx].setVelocityX(neckDir.x * ((this.tailLength - j) / this.tailLength))
          this.tails[j + this.tailIndx].setVelocityY(neckDir.y * ((this.tailLength - j) / this.tailLength))
        } else if (this.selectedAnimal === ROBOT) {
          this.tails[j + this.tailIndx].setVelocityX(neckDir.x)
          this.tails[j + this.tailIndx].setVelocityY(neckDir.y)
        }
      }

      if (this.selectedAnimal === BUNNY) {
        neckDir = new Phaser.Math.Vector2(0, -13)
        neckDir.rotate(this.image.rotation - Math.PI * 0.05)
        for (j = 0; j < this.tailLength; j++) {
          this.tails[j + this.tailIndx + this.tailLength].setVelocityX(neckDir.x * ((this.tailLength - j) / this.tailLength))
          this.tails[j + this.tailIndx + this.tailLength].setVelocityY(neckDir.y * ((this.tailLength - j) / this.tailLength))
        }
      }
    }

    if (this.selectedHat) {
      if (this.hasHat) {
        // 1. calc rotation, which is slightly delayed
        var oldRot = this.hat.rotation
        var targetRot = this.image.rotation
        var dist = Math.abs(targetRot - oldRot)
        if (Math.abs(targetRot) < 1) {
          this.hat.setRotation(Phaser.Math.Angle.RotateTo(oldRot, targetRot, dist * 0.1))
        } else {
          this.hat.setRotation(targetRot)
        }

        // 2. set position
        var a = new Phaser.Math.Vector2(this.image.x, this.image.y)
        var b = new Phaser.Math.Vector2(0, -60 + (Math.min(0.9, Math.abs(targetRot)) * 7))
        b.rotate(this.image.rotation)
        b.x = a.x + b.x
        b.y = a.y + b.y

        var c = new Phaser.Math.Vector2(0, -2)
        c.rotate(this.hat.rotation)
        c.x = b.x + c.x
        c.y = b.y + c.y

        this.hat.setPosition(c.x, c.y)
      } else {
        var oldRot = this.hat.rotation
        this.hat.setRotation(Phaser.Math.Angle.RotateTo(oldRot, oldRot + 0.02 * this.hat.body.velocity.x, 1))// 0.01)) // TODO: use diff as interpSpeed
      }
      if (this.hat.y > 590) {
        this.hat.y = 590
        this.hat.setVelocityY(0)
        this.hat.setIgnoreGravity(true)
      }
    }
    // diff.x = c.x - b.x
    // diff.y = c.y - b.y
    // var angle = diff.angle() + 0.5 * Math.PI
    // this.hat.setRotation(angle)
  }

  pointArmsToCake () {
    if (this.animalDef.hasArms) {
      for (var a = 0; a < this.armLength; a++) {
        this.tails[this.leftArmIndx + a].setVelocityX(10 * this.cakeDirL.x)
        this.tails[this.leftArmIndx + a].setVelocityY(10 * this.cakeDirL.y)
        this.tails[this.rightArmIndx + a].setVelocityX(10 * this.cakeDirR.x)
        this.tails[this.rightArmIndx + a].setVelocityY(10 * this.cakeDirR.y)
      }
    }
  }

  moveArmsApart () {
    if (this.animalDef.hasArms) {
      const magnitude = this.armLength < 2 ? 2 : 8
      const dir = this.tails[this.leftArmIndx].x > this.image.x ? 1 : -1
      this.tails[this.leftArmIndx].setVelocityX(dir * magnitude * 1.2)
      this.tails[this.rightArmIndx].setVelocityX(dir * -magnitude)
    }
  }

  moveLegsApart () {
    if (this.animalDef.hasLegs) {
      const magnitude = this.armLength < 2 ? 2 : 8
      const dir = this.tails[this.leftArmIndx].x > this.image.x ? 1 : -1

      this.tails[this.leftLegIndx].setVelocityX(dir * magnitude * 2)
      this.tails[this.rightLegIndx].setVelocityX(dir * -magnitude * 1.2)
    }
  }

  updateStretch (delta) {
    if (this.stretch > 1) {
      this.stretch = Math.max(this.stretch - (delta * 0.001), 1)
    }

    if (this.strechtDown) {
      this.setScale(this.stretch, 1 / this.stretch)
      this.setPosition(this.image.x * (1 - this.scaleX), this.image.y * (1 - this.scaleY) + (this.stretch - 1) * 15)
    } else {
      this.setScale(1 / this.stretch, this.stretch)
      this.setPosition(this.image.x * (1 - this.scaleX) + (this.stretch - 1) * 15, this.image.y * (1 - this.scaleY))
    }
  }

  quitToTitle () {
    // this.image.setStatic(true)
    // this.image.setVelocityX(0)
    // this.image.setVelocityY(0)
    this.scene.gameover(false, 0)
  }

  preUpdate (time, delta) {
    this.updateTails()
    this.updateStretch(delta)

    if (this.isGameOver) {
      return
    }

    if (this.fellInGap) {
      if (this.image.y >= 680) {
        this.scene.gameover()
        this.image.setVelocityX(0)
      }
      return
    }

    // QQQ
    // if (this.image.y >= 555) {
    // this.onGround(550)
    if (this.image.y >= this.gameoverThreshold) {
      this.scene.gameover()// this.onHit(-90, true)
      this.image.setVelocityX(0)
    }
    // }

    if (!this.hasStarted || this.scene.levelEditor.enabled) {
      return
    }

    if (!this.keyEsc.isDown && this.keyEscWasDown) {
      if (this.scene.isCustomLevel) {
        this.scene.levelEditor.enable()
      } else {
        this.quitToTitle()
      }
    }
    this.keyEscWasDown = this.keyEsc.isDown

    if (this.keyEditor.isDown) {
    // if (!this.scene.levelEditor.enabled) {
      this.scene.levelEditor.enable()
    }

    // if (this.scene.spawner.finishX >= 0 && this.image.x > this.scene.spawner.finishX) {
    //   this.scene.finish()
    // }

    var speed = this.image.body.velocity.x
    var accel = this.scene.finished ? 0.25 * ACCEL : ACCEL
    var maxSpeed = this.scene.finished ? 0.25 * SPEED : SPEED
    if (this.keyRight.isDown) {
      if (this.speed < 0) { accel *= 2 }
      speed += accel * (delta / 1000)
      if (this.image.x > this.scene.spawner.finishX - 400) {
        maxSpeed *= (750 - (this.image.x - (this.scene.spawner.finishX - 400))) / 750
      }
      speed = Math.min(speed, maxSpeed)
      this.image.setVelocityX(speed)
    } else if (this.keyLeft.isDown && this.image.x > -200) { // } && !this.scene.finished) {
      if (this.speed > 0) { accel *= 2 }
      speed -= accel * (delta / 1000)
      speed = Math.max(speed, -maxSpeed)
      this.image.setVelocityX(speed)
    } else if (speed > 0) {
      speed -= DECEL * (delta / 1000)
      speed = Math.max(speed, 0)
      this.image.setVelocityX(speed)
    } else if (speed < 0) {
      speed += DECEL * (delta / 1000)
      speed = Math.min(speed, 0)
      this.image.setVelocityX(speed)
    }

    // if (this.scene.touch) {
    //   if (this.keyLeft.isDown) {
    //     this.scene.touch.leftInputImg.setAlpha(1)
    //   } else {
    //     this.scene.touch.leftInputImg.setAlpha(0.5)
    //   }
    //   if (this.keyRight.isDown) {
    //     this.scene.touch.rightInputImg.setAlpha(1)
    //   } else {
    //     this.scene.touch.rightInputImg.setAlpha(0.5)
    //   }
    // }

    if (!this.image.isStatic() && !this.scene.finished) {
      var rotationSpeed = 0
      if (this.keyRight.isDown) {
        rotationSpeed = 3// 20
      } else if (this.keyLeft.isDown) {
        rotationSpeed = -3// 20
      } else {
        rotationSpeed = (this.image.body.velocity.x / SPEED) * 3// 20
      }
      // var currentAngle = this.image.angle
      this.image.angle += rotationSpeed
    }
  }

  addCombo () {
    this.combo += 1
    this.emit('combo', this.combo)
  }

  addScore () {
    this.nSpikesThisCombo++

    if (this.nBouncesThisCombo <= 1) {
      for (var i = 0; i < this.nSpikesThisCombo; i++) {
        this.addCombo()
      }
    }

    this.score += this.combo
    this.emit('score', this.score)

    this.nBouncesThisCombo = 0
  }

  /**
   * @param {Phaser.Types.Physics.Matter.MatterCollisionData} collisionData
   */
  onCollision (collisionData) {
    if (collisionData.bodyB.gameObject && collisionData.bodyB.gameObject.parentContainer) {
      collisionData.bodyB.gameObject.parentContainer.onHit()
      if (collisionData.bodyB.gameObject.parentContainer.bounce) {
        if (Math.abs(collisionData.collision.penetration.y) > Math.abs(collisionData.collision.penetration.x)) {
          if (collisionData.collision.penetration.y < 0) {
            this.onGround(collisionData.bodyB.bounds.min.y - 75, collisionData.bodyB.gameObject.parentContainer.bounceMP)
            this.lastPlatform = collisionData.bodyB.gameObject.parentContainer

            var mover = collisionData.bodyB.gameObject.parentContainer.moveComponent
            if (mover && mover.waitForBounce && mover.paused) {
              mover.onBounce()
            }
          } else {
            this.image.setVelocityY(-this.image.body.velocity.y)
          }
        } else {
          var dir = Math.sign(this.image.x - collisionData.bodyB.gameObject.x)
          this.image.setVelocityX(dir * Math.abs(this.image.body.velocity.x))
        }
        return
      } else if (collisionData.bodyB.gameObject.parentContainer.lethal) {
        if (!this.isGameOver && collisionData.bodyB.isSensor) {
          const velocity = new Phaser.Math.Vector2(-this.image.body.velocity.x, -(this.image.body.velocity.y))
          const angle = Phaser.Math.RadToDeg(velocity.angle())
          this.onHit(angle, true, collisionData)
          this.scene.spawner.pauseMovers()
        }
      }
      return
    }

    if (collisionData.bodyB.gameObject.name === 'stool' && this.knockedOverCake) {
      this.image.setVelocityY(-20)
    }

    // if (!this.isGameOver && collisionData.bodyB.isSensor) {
    //   const velocity = new Phaser.Math.Vector2(-this.image.body.velocity.x, -(this.image.body.velocity.y))
    //   const angle = Phaser.Math.RadToDeg(velocity.angle())
    //   this.onHit(angle, true, collisionData)
    //   this.scene.spawner.pauseMovers()
    // }
  }

  onHitCake (cake) {
    this.image.setIgnoreGravity(true)

    cake.image.setCollisionGroup(this.scene.collisionGroup2)
    cake.image.setSensor(true)

    if (this.image.body.velocity.y > 0) {
      this.knockedOverCake = false
      cake.image.setStatic(true)
      cake.stoolIm.setStatic(true)

      this.berryP.setPosition(cake.image.x, cake.image.y - 45)
      this.berryP.explode()
      this.image.setVelocityX(0)
      this.image.setVelocityY(0)
      this.image.setSensor(true)

      this.doStretch(1.15, this.image.body.velocity.y > 0)
      this.add(cake.image)

      var desiredCakeDistX = 60
      var desiredCakeDistY = 50

      var leftToCenter = Math.abs(this.tails[this.leftArmIndx].x - cake.image.x)
      var rightToCenter = Math.abs(this.tails[this.rightArmIndx].x - cake.image.x)

      var diffX = 0
      var diffY = 0

      if (rightToCenter > leftToCenter) {
        // console.log('R is further away : ' + rightToCenter + ' : ' + leftToCenter)
        if (this.image.x < cake.image.x) {
          this.cakeDist = new Phaser.Math.Vector2(cake.image.x - this.tails[this.rightArmIndx].x, cake.image.y - this.tails[this.rightArmIndx].y)
          diffX = Math.max(0, this.cakeDist.x - desiredCakeDistX)
          diffY = Math.max(0, this.cakeDist.y - desiredCakeDistY)
        } else {
          this.cakeDist = new Phaser.Math.Vector2(this.tails[this.rightArmIndx].x - cake.image.x, cake.image.y - this.tails[this.rightArmIndx].y)
          diffX = Math.min(0, desiredCakeDistX - this.cakeDist.x)
          diffY = Math.max(0, this.cakeDist.y - desiredCakeDistY)
        }
      } else {
        // console.log('L is further away')
        if (this.image.x < cake.image.x) {
          this.cakeDist = new Phaser.Math.Vector2(cake.image.x - this.tails[this.leftArmIndx].x, cake.image.y - this.tails[this.leftArmIndx].y)
          diffX = Math.max(0, this.cakeDist.x - desiredCakeDistX)
          diffY = Math.max(0, this.cakeDist.y - desiredCakeDistY)
        } else {
          this.cakeDist = new Phaser.Math.Vector2(this.tails[this.leftArmIndx].x - cake.image.x, cake.image.y - this.tails[this.leftArmIndx].y)
          diffX = Math.min(0, desiredCakeDistX - this.cakeDist.x)
          diffY = Math.max(0, this.cakeDist.y - desiredCakeDistY)
        }
      }

      this.image.x += diffX
      this.image.y += diffY

      if (this.image.x < cake.image.x - 50) {
        cake.image.setTexture('cake2', 2)
      } else if (this.image.x > cake.image.x + 50) {
        cake.image.setTexture('cake2', 3)
      } else {
        cake.image.setTexture('cake2', 1)
      }

      // cake splash:
      var shape = new Phaser.Geom.Line(
        this.image.x - 50,
        cake.image.y - 20,
        this.image.x + 50,
        cake.image.y - 20
      )

      this.scene.player.cakePa.setEmitZone({ type: 'random', source: shape })
      this.scene.player.cakePa.setAngle({ min: 245, max: 295 })
      this.scene.player.cakePa.explode()

      this.tryBringToFront(this.leftArmIndx, cake, this.armLength, 0xff0000, diffX, diffY)
      this.tryBringToFront(this.rightArmIndx, cake, this.armLength, 0x00ff00, diffX, diffY)

      if (!this.animalDef.sendTailToBack && !this.animalDef.tailInFront) { // this.selectedAnimal !== BUNNY && this.selectedAnimal !== UNICORN && this.selectedAnimal !== GIRAFFE) {
        this.tryBringToFront(this.tailIndx, cake, this.tailLength, 0x000000, diffX, diffY)
      }
      this.tryBringToFront(this.leftLegIndx, cake, this.legLength, 0xffffff, diffX, diffY)
      this.tryBringToFront(this.rightLegIndx, cake, this.legLength, 0x0000ff, diffX, diffY)

      this.pointToCake = true
      this.cakeDirL = new Phaser.Math.Vector2(cake.image.x - this.tails[this.leftArmIndx].x, cake.image.y - this.tails[this.leftArmIndx].y)
      this.cakeDirL.normalize()
      this.cakeDirR = new Phaser.Math.Vector2(cake.image.x - this.tails[this.rightArmIndx].x, cake.image.y - this.tails[this.rightArmIndx].y)
      this.cakeDirR.normalize()

      this.image.setStatic(true)

      setTimeout(() => {
        try {
          this.heartX = this.image.x
          this.heartY = this.image.y - 80

          if (this.heartX < cake.image.x) {
            this.heartX -= 60
          } else {
            this.heartX += 60
          }

          if (this.selectedAnimal === GIRAFFE) {
            this.heartX = this.tails[this.tailIndx + this.tailLength - 1].x + (this.tails[this.tailIndx + this.tailLength - 1].x < cake.image.x ? -70 : 70)
            this.heartY = this.tails[this.tailIndx + this.tailLength - 1].y - 50
          }

          if (this.heartX < cake.image.x) {
            cake.heartIm.flipX = true
          }

          cake.heartIm.x = this.heartX
          cake.heartIm.y = this.heartY
          cake.heartIm.setVisible(true)
        } catch (e) {}
      }, 2000)
    } else {
      console.log('knocked over cake!')

      this.knockedOverCake = true
      this.image.setIgnoreGravity(false)
      cake.image.setVelocityX(this.image.body.velocity.x * 0.75)
      cake.image.setVelocityY(this.image.body.velocity.y * 0.5)
      setTimeout(() => {
        // TODO: verify this happens
        if (cake) {
          console.log('re-enabling cake collision')
          cake.image.setCollisionGroup(this.scene.collisionGroup1)
          cake.image.setSensor(false)
        }
      }, 100)
    }

    this.scene.finish()
  }

  tryBringToFront (limbIndex, cake, nParts, color, diffX, diffY) {
    if (nParts <= 0) {
      return
    }
    var x = this.tails[limbIndex].x + diffX
    var y = this.tails[limbIndex].y + diffY
    if (x < cake.image.x - 53 || x > cake.image.x + 53 || y < cake.image.y - 45) {
      for (var i = 0; i < nParts; i++) {
        this.bringToTop(this.tails[limbIndex + i])
      }
    }
  }

  /**
   * @param {Phaser.Types.Physics.Matter.MatterCollisionData} collisionData
   */
  onHit (angle, hideTitle, collisionData = null) {
    if (this.hasHat) { // && this.hat.y > this.image.y) {
      this.hasHat = false

      this.hat.setVelocityX(this.image.body.velocity.x)
      this.hat.setVelocityY(Math.min(-4, this.image.body.velocity.y))
      this.hat.setIgnoreGravity(false)
    }

    this.doStretch(1.25, this.image.body.velocity.y > 0)

    this.image.setIgnoreGravity(true)

    if (this.image.x > this.scene.spawner.finishX && collisionData) {
      var shape
      if (collisionData.collision.supports.length > 1) {
        shape = new Phaser.Geom.Line(
          Math.min(collisionData.collision.supports[0].x, collisionData.collision.supports[1].x) - 10,
          collisionData.collision.supports[0].y,
          Math.max(collisionData.collision.supports[0].x, collisionData.collision.supports[1].x) + 10,
          collisionData.collision.supports[1].y)
      } else {
        shape = new Phaser.Geom.Line(
          collisionData.collision.supports[0].x - 5,
          collisionData.collision.supports[0].y,
          collisionData.collision.supports[0].x + 5,
          collisionData.collision.supports[0].y)
      }

      this.image.setIgnoreGravity(true)

      if (this.image.body.velocity.y > 0 && this.image.y < 500) {
        console.log('=============================================>>> NOT SURE IF THIS CODE SHOULD BE EXECUTED STIL?????')
        collisionData.bodyB.gameObject.setCollisionGroup(this.scene.collisionGroup2)
        collisionData.bodyB.gameObject.setCollisionCategory(this.scene.collisionCategory3)
        collisionData.bodyB.gameObject.setStatic(true)
        // }

        // if (this.image.body.velocity.y > 0 && this.image.y < 500) { // this.image.x > this.scene.spawner.cakeIm.x - 100 && this.image.x < this.scene.spawner.cakeIm.x + 100) {
        // if (this.image.x < this.scene.spawner.cakeIm.x - 50) {
        //   this.scene.spawner.cakeIm.setTexture('cake2', 2)
        // } else if (this.image.x > this.scene.spawner.cakeIm.x + 50) {
        //   this.scene.spawner.cakeIm.setTexture('cake2', 3)
        // } else {
        //   this.scene.spawner.cakeIm.setTexture('cake2', 1)
        // }

        // collisionData.bodyB.gameObject.setCollisionGroup(this.scene.collisionGroup2)
        // collisionData.bodyB.gameObject.setCollisionCategory(this.scene.collisionCategory3)

        // this.berryP.setPosition(this.scene.spawner.cakeIm.x, this.scene.spawner.cakeIm.y - 45)
        // this.berryP.explode()

        // // this.image.setStatic(false)
        // this.image.setVelocityX(0)
        // this.image.setVelocityY(0.15)
      } else {
        // point arms towards cake??

        this.image.setStatic(true)
        this.image.setVelocityX(0)
        this.image.setVelocityY(0)
      }

      this.cakePa.setEmitZone({ type: 'random', source: shape })
      // this.cakePa.setAngle({ min: angle - 40, max: angle + 40 })
      this.cakePa.setAngle({ min: 245, max: 295 })
      this.cakePa.explode()
      // this.scene.finish()

      // this.scene.spawner.heartIm.x = this.image.x + 70
      // this.scene.spawner.heartIm.y = this.image.y - 70
      // if (this.image.x < this.scene.spawner.finishX + 500) {
      //   this.scene.spawner.heartIm.x -= 140
      //   this.scene.spawner.heartIm.flipX = true
      // }
      // setTimeout(() => {
      //   this.scene.spawner.heartIm.setVisible(true)
      // }, 1000)
    } else {
      this.image.setStatic(true)
      this.image.setVelocityX(0)
      this.image.setVelocityY(0)
      // this.scene.cameras.main.shake(50, 0.01)

      collisionData.bodyB.gameObject.parentContainer.makeEasier()
      this.scene.gameover(hideTitle)
    }
  }

  onGround (groundY = 550, bounceMP = 1) {
    const gap = this.scene.spawner.isGapAt(this.image.x, SIZE * 0.35)
    if (gap >= 0) {
      const bounceDir = this.scene.spawner.getBounceDirAtGap(gap, this.image.x, SIZE)
      if (bounceDir !== 0) {
        // this.onHit(bounceDir > 0 ? -45 : -135, true)
        this.fellInGap = true
        this.image.setVelocityX(Math.sign(bounceDir) * 5)
      }
      return
    }

    // console.log('onGround, set lastGroundY to: ' + (groundY + 25))
    this.lastGroundY = groundY + 25

    if (this.hasHat && this.hat.y > this.image.y) {
      this.hasHat = false

      this.hat.setVelocityX(this.image.body.velocity.x)
      this.hat.setVelocityY(-20)
      this.hat.setIgnoreGravity(false)
    }
    //    var v = this.image.body.velocity.x * 3
    //  this.explode.setAngle({ min: 225 + v, max: 315 + v })
    this.explode.setPosition(this.image.x - 5, groundY + 50)
    this.explode.explode()

    this.explode2.setPosition(this.image.x + 5, groundY + 50)
    this.explode2.explode()

    this.exhaust.on = true
    setTimeout(() => { this.exhaust.on = false }, 40)

    this.doStretch(1.25, true)

    this.image.y = groundY

    var vel = this.hasStarted ? -26 : -22
    vel *= bounceMP
    this.image.setVelocityY(vel)

    this.nBouncesThisCombo++
    this.nSpikesThisCombo = 0

    if (this.nBouncesThisCombo >= 2) {
      this.combo = 1
      this.emit('combo', this.combo)
    }
  }

  teleportToFinish () {
    this.image.x = this.scene.spawner.finishX
    this.image.y = -200

    this.image.setVelocityX(0)
    this.image.setVelocityY(0)

    this.scene.cameraController.onTeleport()
  }

  pause () {
    this.image.setStatic(true)
  }

  unpause () {
    this.image.setStatic(false)
  }
}
